jQuery(document).ready(function ($) {
    "use strict";

    // Add spacing to the footer if a sticky banner is enabled
    if ( $('.sticky-banner').length ) {

        if ( $(document).width() >= 576 ) {
            $('.main-footer').css({'margin-bottom': $('.sticky-banner').outerHeight()});
        }
    }
});
